export default "__VITE_ASSET__789cdec6__"